import styled from 'styled-components';
import {
  white,
  IconChevronUp,
  screenXsMax,
  spacer16,
  spacer32,
  spacer64,
  screenMdMax,
} from '@spotify-internal/encore-web';
import Header from '../../atoms/Header';
import Container from '../../atoms/Container';

const iconSize = '24px';

export const List = styled.ul`
  list-style: none;
  margin: 0 auto 0 auto;
  padding: 0;
  max-width: ${screenMdMax};
`;

export const ListItem = styled.li`
  border-bottom: 1px solid var(--background-tinted-highlight, ${white});
  &:last-child {
    border-bottom: unset;
  }

  &:hover > details > summary,
  details[open] > summary {
    background-color: var(--background-elevated-highlight, #f0f0f0);
    > div {
      text-decoration: underline;
    }
  }
`;

export const ExpandIcon = styled(IconChevronUp)`
  vertical-align: middle;
  transform: rotate(180deg);
  width: ${iconSize};
  height: ${iconSize};
`;

export const QuestionTitleText = styled.div`
  display: inline-block;
  vertical-align: middle;
  padding-right: 10px;
  width: calc(100% - ${iconSize});
  box-sizing: border-box;
  &:hover {
    text-decoration: underline;
  }
`;

export const QuestionTitle = styled.summary`
  cursor: pointer;
  font-size: 18px;
  font-weight: 900;
  padding: ${spacer16};
  margin-top: 2px;
  position: relative;

  list-style: none;
  &::-webkit-details-marker {
    display: none;
  }

  outline: none;

  &:focus-visible {
    outline: 2px solid white;
    outline-offset: -2px;
    border-radius: 8px;
  }
`;

export const QuestionContainer = styled.details`
  &:not([open]) {
    max-height: 120px;
    overflow: hidden;
  }

  &[open] {
    transition: max-height 1s linear;
    background-color: var(--background-elevated-base, #f0f0f0);
    max-height: 800px;
  }

  color: var(--text-base, #fff);

  &[open] ${ExpandIcon} {
    transform: rotate(0deg);
  }
`;

export const QuestionContent = styled.p`
  padding: 15px 32px 32px 32px;

  margin: 0;

  a {
    color: inherit;
    text-decoration: underline;
  }
`;

export const CustomFaqHeader = styled(Header)`
  margin-bottom: 0;
  -webkit-font-smoothing: antialiased;

  h2 {
    font-weight: 700;
    padding: 0;
    margin: 0;
    font-size: ${spacer32};
  }

  h3 {
    font-size: ${spacer16};
  }
`;

export const FaqMoreQuestions = styled.p`
  -webkit-font-smoothing: antialiased;

  text-align: center;
  width: 100% !important;
  margin-top: 0;
  font-size: ${spacer16};
  a {
    color: var(--text-base, ${white});
  }
`;
export const FaqImageContainer = styled(Container)`
  background-repeat: no-repeat;
  background-size: cover;
  > article {
    padding-left: 0;
    padding-right: 0;
    padding-bottom: ${spacer64};
  }
  @media (max-width: ${screenXsMax}) {
    background-image: none !important;
  }

  a:hover {
    font-weight: 700;
    cursor: pointer;
  }
`;
